export type SnippetMetadataPayload = {
	adfContent: string;
};

export type SnippetMetadataSuggestion = {
	name: string;
	description: string;
	confidence: number;
};

export type SnippetMetadataResponse = {
	suggestions: SnippetMetadataSuggestion[];
};

export function isValidSnippetMetadataResponse(value: unknown): value is SnippetMetadataResponse {
	return (
		!!value &&
		typeof value === 'object' &&
		'suggestions' in value &&
		Array.isArray((value as SnippetMetadataResponse).suggestions)
	);
}
